import React, {useState} from 'react';
import {SettingContainer} from './style';
import Tools from "../header/components/tools";

const Setting = () => {
  const [toolPanel, showToolPanel] = useState(false);
  return (
    <SettingContainer>
      <i
        title="تنظیمات"
        className={
          (toolPanel ? "pressed " : "") + "left-side-icon icon mapsa-gear"
        }
        onClick={() => showToolPanel(!toolPanel)}
      />
      {toolPanel && (
        <Tools
          show={ toolPanel}
          handleShow={(show)=>showToolPanel(show)}
        />
      )}
    </SettingContainer>
  );
};

export default Setting;